<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="open()">添加</el-button>

    <el-dialog title="添加" width="400px" :visible.sync="dialogVisible" @close="closeDialog" :before-close="closeDialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="下单数量比例" prop="qtyRate">
          <el-input-number :precision="4" :step="0.1" v-model.trim="ruleForm.qtyRate" placeholder="请输入"></el-input-number>
        </el-form-item>
        <el-form-item label="成交数量比例" prop="dealRate">
          <el-input-number :precision="4" :step="0.1" v-model.trim="ruleForm.dealRate"
            placeholder="请输入"></el-input-number>
        </el-form-item>

        <el-form-item label="成交数量比例" prop="symbol">
          <el-select v-model="ruleForm.symbol" class='btn' clearable filterable placeholder="请选择交易对">
            <el-option v-for="item in pairList" :key="item.id" :label="item.symbol" :value="item.symbol">
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import api from '../../api'
export default {
  props: ['pairList'],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        qtyRate: 0,
        dealRate: 0,
        symbol: ""
      },
      rules: {
        qtyRate: [
          { required: true, message: "请输入下单数量比例", trigger: "blur" },

        ],
        dealRate: [
          { required: true, message: "请输入成交数量比例", trigger: "blur" },

        ],
        symbol: [
          { required: true, message: '请选择交易对', trigger: "blur" },
        ]
      },
    };
  },
  methods: {
    closeDialog() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        qtyRate: "",
        dealRate: "",
        symbol: ""
      }
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          api.robotAdd({
            ...this.ruleForm
          }).then(res => {
            if (res.code == 0) {
              this.$message.success('操作成功！');
              this.closeDialog()
              this.$emit('refresh');
            }
          })
        }
      })

    },
  },
};
</script>

<style lang="less" scoped></style>
